import { render, staticRenderFns } from "./ServiceAutodiscovery.vue?vue&type=template&id=39161c37&scoped=true"
import script from "./ServiceAutodiscovery.vue?vue&type=script&lang=js"
export * from "./ServiceAutodiscovery.vue?vue&type=script&lang=js"
import style0 from "./ServiceAutodiscovery.vue?vue&type=style&index=0&id=39161c37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39161c37",
  null
  
)

export default component.exports